import { render, staticRenderFns } from "./DeathAndDisabilityBenefit.vue?vue&type=template&id=57ac1848"
import script from "./DeathAndDisabilityBenefit.vue?vue&type=script&lang=js"
export * from "./DeathAndDisabilityBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports